import { TypeEvent, TypeEventResult } from "@lexriver/type-event"

export class SwipeEvent{
    protected startX:number = 0
    protected startY:number = 0
    protected startDatetime:Date = new Date()

    public eventLeftToRight = new TypeEvent()
    public eventRightToLeft = new TypeEvent()
    // public eventTopToBottom = new TypeEvent()
    // public eventBottomToTop = new TypeEvent()


    public eventTouchStart = new TypeEvent<(p:{x:number, y:number})=>TypeEventResult>()
    public eventTouchMove = new TypeEvent<(p:{x:number, y:number, distanceX:number, distanceY:number, startX:number, startY:number})=>TypeEventResult>()
    public eventTouchEnd = new TypeEvent<(p:{x:number, y:number, distanceX:number, distanceY:number, startX:number, startY:number, milliseconds:number})=>TypeEventResult>()

    constructor(protected htmlElement:HTMLElement, protected options?:{
        minDistancePx?:number, 
        maxTimeMs?:number
        preventScrolling?:boolean
    }){
        this.options = this.options ?? {}
        this.options.minDistancePx = this.options.minDistancePx ?? window.innerWidth*0.382
        this.options.maxTimeMs = this.options.maxTimeMs ?? 2200

        
        this.htmlElement.addEventListener('touchstart', async (e) => {
            this.startX = e.changedTouches[0].pageX
            this.startY = e.changedTouches[0].pageY
            this.startDatetime = new Date()
            await this.eventTouchStart.triggerAsync({x: this.startX, y: this.startY})
            //e.preventDefault()
        })

        this.htmlElement.addEventListener('touchmove', async (e) => {
            
            if(this.options?.preventScrolling){
                e.preventDefault() // prevent scrolling?
            }

            const x = e.changedTouches[0].pageX
            const y = e.changedTouches[0].pageY

            const distanceX = x-this.startX
            const distanceY = y-this.startY
            //console.log('touch-move', distanceX, distanceY)
            await this.eventTouchMove.triggerAsync({x, y, distanceX, distanceY, startX: this.startX, startY: this.startY})
        })

        this.htmlElement.addEventListener('touchend', async (e) => {
            
            const distanceX = e.changedTouches[0].pageX - this.startX
            const distanceY = e.changedTouches[0].pageY - this.startY
            const msTaken = new Date().valueOf() - this.startDatetime.valueOf()
            await this.eventTouchEnd.triggerAsync({
                x: e.changedTouches[0].pageX, 
                y: e.changedTouches[0].pageY,
                distanceX,
                distanceY,
                milliseconds: msTaken,
                startX: this.startX, 
                startY:  this.startY
            })
            if(msTaken < this.options!.maxTimeMs!){
                if(distanceX > this.options!.minDistancePx!){
                    await this.eventLeftToRight.triggerAsync()

                } else if(distanceX < 0-this.options!.minDistancePx!){
                    await this.eventRightToLeft.triggerAsync()

                }

                // if(distanceY > p.minDistancePx!){
                //     this.eventTopToBottom.triggerAsync()

                // } else if(distanceY < 0-p.minDistancePx!){
                //     this.eventBottomToTop.triggerAsync()
                    
                // }
            }
        })


    }
}

